import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PUBLIC_BASE } from './config';
import PublicLayout from '../../components/public/PublicLayout';

export default function PublicReviewPaymentFailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get('code') || '';
  const message = searchParams.get('message') || '';

  return (
    <PublicLayout>
      <div className="flex flex-col justify-center items-center h-64 gap-3">
        <div className="text-red-500 font-bold text-lg">결제 실패</div>
        {code && <div className="text-slate-500 text-sm">오류 코드: {code}</div>}
        {message && <div className="text-slate-400 text-sm">{message}</div>}
        <button className="px-4 py-2 rounded-xl bg-sky-600 text-white hover:bg-sky-500 transition-colors mt-2"
          onClick={() => navigate(`${PUBLIC_BASE}/review/write`)}>
          다시 시도
        </button>
      </div>
    </PublicLayout>
  );
}
